'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
export const Route = createFileRoute('/_staff/settings/notification-and-response/_layout/settings/')({
  component: NotificationSettings
});
function NotificationSettings() {
  // 設定タブは未実装（空のプレースホルダ）
  return <VStack className="px-12 py-6" />;
}